function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "100%",
  y1: "88.281%",
  x2: "0%",
  y2: "11.719%",
  id: "CsvSourceIcon_svg__8_a"
}, React.createElement("stop", {
  stopColor: "#596168",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7B8B99",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M400 12a2 2 0 011.732 1H408a1 1 0 110 2l-6.268.001a2 2 0 01-3.464 0L394 15a1 1 0 110-2h4.268A2 2 0 01400 12zm5-5a2 2 0 011.732 1H408a1 1 0 110 2l-1.268.001a2 2 0 01-3.464 0L394 10a1 1 0 110-2h9.268A2 2 0 01405 7zm-6-5a2 2 0 011.732 1H408a1 1 0 110 2l-7.268.001a2 2 0 01-3.464 0L394 5a1 1 0 110-2h3.268A2 2 0 01399 2z",
  transform: "translate(-393 -2)",
  fill: "url(#CsvSourceIcon_svg__8_a)",
  fillRule: "evenodd"
});

var SvgCsvSourceIcon = function SvgCsvSourceIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _ref, _ref2);
};

export default SvgCsvSourceIcon;